export default __webpack_public_path__ + "static/about-us-hero--mobile-2a7b2b1e142c048e258d3ddb196e640f.webp";